import {
  SELLER_CONTACT_LOAD_ATTEMPT,
  SELLER_CONTACT_LOAD_SUCCESS,
  SELLER_CONTACT_LOAD_FAILED,
  ///////////////////////
  SELLER_CONTACT_SAVE_ATTEMPT,
  SELLER_CONTACT_SAVE_SUCCESS,
  SELLER_CONTACT_SAVE_FAILED,
} from "../types/sellerContactTypes";

const INITIAL_STATE = {
  loading: false,
  saving: false,
  email: false,
  phone: false,
  chat: false,
  whatsapp: false,
  emailAddress: "",
  phoneNumber: "",
  loaded: false,
  error: "",
};

function sellerContact(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SELLER_CONTACT_LOAD_ATTEMPT:
      return { ...state, loading: true, error: "" };

    case SELLER_CONTACT_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        email: Boolean(action.data.Email),
        phone: Boolean(action.data.Phone),
        chat: Boolean(action.data.Chat),
        whatsapp: Boolean(action.data.Whatsapp),
        emailAddress: action.data.EmailAddress || "",
        phoneNumber: action.data.PhoneNumber || "",
        error: "",
      };

    case SELLER_CONTACT_LOAD_FAILED:
      return { ...state, loading: false, error: action.error };

    case SELLER_CONTACT_SAVE_ATTEMPT:
      return { ...state, saving: true, error: "" };

    case SELLER_CONTACT_SAVE_SUCCESS:
      return {
        ...state,
        saving: false,
        loaded: true,
        email: Boolean(action.data.Email),
        phone: Boolean(action.data.Phone),
        chat: Boolean(action.data.Chat),
        whatsapp: Boolean(action.data.Whatsapp),
        emailAddress: action.data.EmailAddress || "",
        phoneNumber: action.data.PhoneNumber || "",
        error: "",
      };

    case SELLER_CONTACT_SAVE_FAILED:
      return { ...state, saving: false, error: action.error };

    default:
      return state;
  }
}

export default sellerContact;
